import React from 'react';
import ImageGrid from './partials/image-grid';

const Body = () => (
  <section className="body">
    <ImageGrid />
  </section>
);

export default Body;
